import { RG_TYPE } from '../../types/rg-type.js';

/** types that affect parent geometry */
const RgAffectsParentGeometry = {
    [RG_TYPE.World]: [],
    [RG_TYPE.Site]: [],
    [RG_TYPE.Zone]: [],
    [RG_TYPE.Plot]: [],
    [RG_TYPE.Building]: [],
    [RG_TYPE.Core]: [],
    [RG_TYPE.Entrance]: [],
    [RG_TYPE.Corridor]: [],
    [RG_TYPE.TechnicalSpace]: [],
    [RG_TYPE.TechnicalSpaceRoom]: [],
    [RG_TYPE.Apartment]: [],
    [RG_TYPE.Module]: [],
    [RG_TYPE.Balcony]: [],
    [RG_TYPE.Roof]: [],
    [RG_TYPE.Ceiling]: [],
    [RG_TYPE.Floor]: [],
    [RG_TYPE.Wall]: [],
    [RG_TYPE.Facade]: [],
    [RG_TYPE.Beam]: [],
    [RG_TYPE.Door]: [RG_TYPE.Wall],
    [RG_TYPE.Window]: [RG_TYPE.Wall],
    [RG_TYPE.Opening]: [RG_TYPE.Wall, RG_TYPE.Facade],
    [RG_TYPE.Column]: [],
    [RG_TYPE.Room]: [],
    [RG_TYPE.Parapet]: [],
    [RG_TYPE.EmptySpace]: [],
    [RG_TYPE.Glazing]: [RG_TYPE.Facade]
};

export { RgAffectsParentGeometry };
//# sourceMappingURL=rg-affects-parent-geometry.js.map
